import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../karoltruculoarq/servicos_karoltruculoarq.module.scss';

// Ícones e imagens
import { ArrowLeft } from 'lucide-react';
import gal1Image1 from '../karoltruculoarq/src/galeria/gal1Image1.jpeg';
import gal1Image2 from '../karoltruculoarq/src/galeria/gal1Image2.jpeg';
import gal1Image3 from '../karoltruculoarq/src/galeria/gal1Image3.jpeg';
import gal1Image4 from '../karoltruculoarq/src/galeria/gal1Image4.jpeg';
import gal1Image5 from '../karoltruculoarq/src/galeria/gal1Image5.jpeg';
import gal1Image6 from '../karoltruculoarq/src/galeria/gal1Image6.jpeg';
import gal1Image7 from '../karoltruculoarq/src/galeria/gal1Image7.jpeg';
import gal2Image1 from '../karoltruculoarq/src/galeria/gal2Image1.jpeg';
import gal2Image2 from '../karoltruculoarq/src/galeria/gal2Image2.jpeg';
import gal2Image3 from '../karoltruculoarq/src/galeria/gal2Image3.jpeg';
import gal2Image4 from '../karoltruculoarq/src/galeria/gal2Image4.jpeg';
import gal3Image1 from '../karoltruculoarq/src/galeria/gal3Image1.jpeg';
import gal3Image2 from '../karoltruculoarq/src/galeria/gal3Image2.jpeg';
import gal3Image3 from '../karoltruculoarq/src/galeria/gal3Image3.jpeg';
import gal3Image4 from '../karoltruculoarq/src/galeria/gal3Image4.jpeg';
import gal3Image5 from '../karoltruculoarq/src/galeria/gal3Image5.jpeg';
import gal3Image6 from '../karoltruculoarq/src/galeria/gal3Image6.jpeg';
import gal3Image7 from '../karoltruculoarq/src/galeria/gal3Image7.jpeg';
import gal3Image8 from '../karoltruculoarq/src/galeria/gal3Image8.jpeg';
import gal3Image9 from '../karoltruculoarq/src/galeria/gal3Image9.jpeg';
import gal3Image10 from '../karoltruculoarq/src/galeria/gal3Image10.jpeg';
import gal3Image11 from '../karoltruculoarq/src/galeria/gal3Image11.jpeg';
import gal4Image1 from '../karoltruculoarq/src/galeria/gal4Image1.jpeg';
import gal4Image2 from '../karoltruculoarq/src/galeria/gal4Image2.jpeg';
import gal4Image3 from '../karoltruculoarq/src/galeria/gal4Image3.jpeg';
import gal5Image1 from '../karoltruculoarq/src/galeria/gal5Image1.jpeg';
import gal5Image2 from '../karoltruculoarq/src/galeria/gal5Image2.jpeg';
import gal5Image3 from '../karoltruculoarq/src/galeria/gal5Image3.jpeg';
import gal5Image4 from '../karoltruculoarq/src/galeria/gal5Image4.jpeg';
import gal5Image5 from '../karoltruculoarq/src/galeria/gal5Image5.jpeg';
import gal5Image6 from '../karoltruculoarq/src/galeria/gal5Image6.jpeg';
import gal5Image7 from '../karoltruculoarq/src/galeria/gal5Image7.jpeg';
import gal5Image8 from '../karoltruculoarq/src/galeria/gal5Image8.jpeg';
import gal5Image9 from '../karoltruculoarq/src/galeria/gal5Image9.jpeg';
import gal5Image10 from '../karoltruculoarq/src/galeria/gal5Image10.jpeg';
import gal6Image1 from '../karoltruculoarq/src/galeria/gal6Image1.jpeg';
import gal6Image2 from '../karoltruculoarq/src/galeria/gal6Image2.jpeg';
import gal6Image3 from '../karoltruculoarq/src/galeria/gal6Image3.jpeg';
import gal6Image4 from '../karoltruculoarq/src/galeria/gal6Image4.jpeg';
import gal6Image5 from '../karoltruculoarq/src/galeria/gal6Image5.jpeg';
import gal6Image6 from '../karoltruculoarq/src/galeria/gal6Image6.jpeg';
import gal7Image1 from '../karoltruculoarq/src/galeria/gal7Image1.jpeg';
import gal7Image2 from '../karoltruculoarq/src/galeria/gal7Image2.jpeg';
import gal7Image3 from '../karoltruculoarq/src/galeria/gal7Image3.jpeg';
import gal7Image4 from '../karoltruculoarq/src/galeria/gal7Image4.jpeg';
import gal7Image5 from '../karoltruculoarq/src/galeria/gal7Image5.jpeg';
import gal7Image6 from '../karoltruculoarq/src/galeria/gal7Image6.jpeg';
import gal8Image1 from '../karoltruculoarq/src/galeria/gal8Image1.jpeg';
import gal8Image2 from '../karoltruculoarq/src/galeria/gal8Image2.jpeg';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';

const Servicos_karoltruculoarq: React.FC = () => {
    const navigate = useNavigate();
    const [selectedGallery, setSelectedGallery] = useState<string | null>(null);
    const [carouselIndex, setCarouselIndex] = useState<number | null>(null);
    const [selectedCategory, setSelectedCategory] = useState<string | null>("projeto_comercial");

    // Estrutura de galerias
    const galleries: Record<string, string[]> = {
        gal1: [gal1Image1, gal1Image2, gal1Image3, gal1Image4, gal1Image5, gal1Image6, gal1Image7],
        gal2: [gal2Image1, gal2Image2, gal2Image3, gal2Image4],
        gal3: [gal3Image1, gal3Image2, gal3Image3, gal3Image4, gal3Image5, gal3Image6, gal3Image7, gal3Image8, gal3Image9, gal3Image10, gal3Image11],
        gal4: [gal4Image1, gal4Image2, gal4Image3],
        gal5: [gal5Image1, gal5Image2, gal5Image3, gal5Image4, gal5Image5, gal5Image6, gal5Image7, gal5Image8, gal5Image9, gal5Image10],
        gal6: [gal6Image1, gal6Image2, gal6Image3, gal6Image4, gal6Image5, gal6Image6],
        gal7: [gal7Image1, gal7Image2, gal7Image3, gal7Image4, gal7Image5, gal7Image6],
        gal8: [gal8Image1, gal8Image2],
    };

    // Funções de navegação
    const handleBack = () => {
        if (carouselIndex !== null) {
            setCarouselIndex(null);
        } else if (selectedGallery) {
            setSelectedGallery(null);
        } else {
            navigate('/karoltruculoarq');
        }
    };

    return (
        <div className={styles.servicos_karoltruculoarq}>
            {/* Header */}
            <div className={styles.header}>
                <button className={styles.backButton} onClick={handleBack}>
                    <ArrowLeft size={22} />
                </button>
                <h1 className="mb-0">Galeria</h1>
            </div>

            {/* Conteúdo principal */}
            <div className={styles.mainContent}>
                {/* Se ainda não escolheu galeria */}
                {!selectedGallery && (
                    <>
                        <div
                            className={styles.categorySelector}
                            onMouseDown={(e) => {
                                const container = e.currentTarget;
                                container.dataset.dragging = "true";
                                container.dataset.startX = e.pageX.toString(); // posição inicial do mouse
                                container.dataset.scrollLeft = container.scrollLeft.toString(); // scroll inicial
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.dataset.dragging = "false";
                            }}
                            onMouseUp={(e) => {
                                e.currentTarget.dataset.dragging = "false";
                            }}
                            onMouseMove={(e) => {
                                const container = e.currentTarget;
                                if (container.dataset.dragging === "true") {
                                    e.preventDefault();
                                    const startX = Number(container.dataset.startX);
                                    const scrollLeftStart = Number(container.dataset.scrollLeft);
                                    const walk = e.pageX - startX; // distância movida
                                    container.scrollLeft = scrollLeftStart - walk; // scroll acumulado
                                }
                            }}
                            onTouchStart={(e) => {
                                const container = e.currentTarget;
                                container.dataset.dragging = "true";
                                container.dataset.startX = e.touches[0].pageX.toString();
                                container.dataset.scrollLeft = container.scrollLeft.toString();
                            }}
                            onTouchMove={(e) => {
                                const container = e.currentTarget;
                                if (container.dataset.dragging === "true") {
                                    const startX = Number(container.dataset.startX);
                                    const scrollLeftStart = Number(container.dataset.scrollLeft);
                                    const walk = e.touches[0].pageX - startX;
                                    container.scrollLeft = scrollLeftStart - walk;
                                }
                            }}
                            onTouchEnd={(e) => {
                                e.currentTarget.dataset.dragging = "false";
                            }}
                        >
                            <button
                                className={`${styles.categoryButton} ${selectedCategory === "projeto_comercial" ? styles.active : ""}`}
                                onClick={() => setSelectedCategory("projeto_comercial")}
                            >
                                Projetos comerciais
                            </button>
                            <button
                                className={`${styles.categoryButton} ${selectedCategory === "projeto_residencial" ? styles.active : ""}`}
                                onClick={() => setSelectedCategory("projeto_residencial")}
                            >
                                Projetos residenciais
                            </button>
                            <button
                                className={`${styles.categoryButton} ${selectedCategory === "grandes_obras" ? styles.active : ""}`}
                                onClick={() => setSelectedCategory("grandes_obras")}
                            >
                                Grandes obras
                            </button>
                            <button
                                className={`${styles.categoryButton} ${selectedCategory === "obra" ? styles.active : ""}`}
                                onClick={() => setSelectedCategory("obra")}
                            >
                                Obras entregues
                            </button>
                        </div>
                        <div className={styles.galleryGrid}>
                            {Object.entries(galleries)
                                .filter(([key]) => {
                                    if (!selectedCategory) return true;
                                    if (selectedCategory === "projeto_comercial") return ["gal6", "gal7"].includes(key);
                                    if (selectedCategory === "projeto_residencial") return ["gal2", "gal8"].includes(key);
                                    if (selectedCategory === "grandes_obras") return ["gal3", "gal1"].includes(key);
                                    if (selectedCategory === "obra") return ["gal5", "gal4"].includes(key);
                                    return false;
                                })
                                .map(([key, images], index) => (
                                    <div
                                        key={index}
                                        className={styles.folderCard}
                                        onClick={() => setSelectedGallery(key)}
                                    >
                                        <img src={images[0]} alt={`Galeria ${index + 1}`} />
                                    </div>
                                ))}
                        </div>
                    </>
                )}

                {/* Exibe imagens da galeria selecionada */}
                {selectedGallery && carouselIndex === null && (
                    <div className={styles.imageGrid}>
                        {galleries[selectedGallery].map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt={`Imagem ${i + 1}`}
                                onClick={() => setCarouselIndex(i)}
                            />
                        ))}
                    </div>
                )}

                {/* Exibe carrossel */}
                {carouselIndex !== null && selectedGallery && (
                    <div className={styles.carouselOverlay}>
                        <button className={styles.closeButton} onClick={() => setCarouselIndex(null)}>
                            ×
                        </button>
                        <img
                            src={galleries[selectedGallery][carouselIndex]}
                            alt="Imagem ampliada"
                            className={styles.carouselImage}
                        />
                        <div className={styles.carouselControls}>
                            <button
                                style={{ color: "#4c0f2e" }}
                                onClick={() =>
                                    setCarouselIndex(
                                        (carouselIndex - 1 + galleries[selectedGallery].length) %
                                        galleries[selectedGallery].length
                                    )
                                }
                            >
                                ‹
                            </button>
                            <button
                                style={{ color: "#4c0f2e" }}
                                onClick={() =>
                                    setCarouselIndex(
                                        (carouselIndex + 1) % galleries[selectedGallery].length
                                    )
                                }
                            >
                                ›
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <h2>Karol Trüculo - Arquitetura e Interiores</h2>
                <div className={styles.footerIcons}>
                    <a
                        href="https://wa.me/5517981304321?text=Olá! vim pelo link na bio e gostaria de mais informações..."
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="34" color="#fff" />
                    </a>
                    <a
                        href="https://www.instagram.com/karoltruculoarq"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon height="28" color="#fff" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/Wsn1CCY3ZQfi2LSL9"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon height="34" color="#fff" />
                    </a>
                </div>
            </div>

            {/* Botão flutuante WhatsApp */}
            <a
                href="https://wa.me/5517981304321?text=Olá! vim pelo link na bio e gostaria de mais informações..."
                target="_blank"
                rel="noopener noreferrer"
                className={styles.floatingWhatsapp}
            >
                <WhatsappIcon height="32" color="#fff" />
            </a>
        </div>
    );
};

export default Servicos_karoltruculoarq;
